export default __webpack_public_path__ + "static/media/kitOnBanner.4a1302b1.svg";